import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../constants/config';
import { createBaseQuery } from './baseQuery';

export const endpointsApi = createApi({
  reducerPath: 'endpointsApi',
  baseQuery: createBaseQuery(`${config.apiUrl}/api`),
  tagTypes: ['Endpoint'],
  endpoints: (builder) => ({
    getAllEndpoints: builder.query<string[], void>({
      query: () => '/endpoints/all',
      providesTags: ['Endpoint'],
    }),
  }),
});

export const {
  useGetAllEndpointsQuery,
} = endpointsApi;